export interface RaddTimeRange {
  end: string;
  start: string;
}

/**
 * Response payload of `/glad-radd/layer`. Same `tileUrl` as RADD, plus an
 * optional `dataDate` ("alerts current as of", `YYYY-MM-DD`) — the newest RADD
 * publish date the windows are anchored on. Best-effort: can be `null` and must
 * never block rendering the tiles.
 */
export interface GladRaddLayer {
  tileUrl: string;
  dataDate?: string | null;
}

export interface AlertsRaddZone {
  alert_count: number;
  alert_date?: string | null;
  alerts_found: boolean;
  error?: string;
  time_range: RaddTimeRange;
  total_alert_area_ha: number;
  geography: string;
  zone_id: number;
}

export interface DeforestationSubscriptionStatus {
  username: string;
  zones: number[];
  subscribed: boolean;
}

/**
 * Which deforestation alert tile layer a parent zone uses:
 * - `radd`       → the plain RADD (Sentinel-1 radar) layer (`/radd/layer`), the default.
 * - `glad`       → GLAD-L only (Landsat optical) layer (`/glad/layer`).
 * - `glad-radd`  → the combined GLAD-L + RADD integrated layer (`/glad-radd/layer`).
 * Chosen per parent zone in the deforestation-layer settings.
 */
export type DeforestationLayerChoice = 'radd' | 'glad' | 'glad-radd';

export const DEFAULT_DEFORESTATION_LAYER: DeforestationLayerChoice = 'radd';
